import { useProductTabContext } from '../ProductTabContext'
import { createInitialProduct } from '../utils'
import ProductForm from './ProductForm/ProductForm'
import { ProductSchemaType } from './ProductForm/productValidationSchema'

const CreateProductModal = () => {
  const { customerId } = useProductTabContext()

  const initialProduct = createInitialProduct(customerId)

  return <ProductForm product={initialProduct as ProductSchemaType} isDisabled={false} />
}

export default CreateProductModal
